import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ImageVariableWidthBlockConfig } from '@front-platform/content-builder';
import { imageVariableWidthBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
export interface ImageVariableWidthBlockRuntimeConfig {}

export type ImageVariableWidthBlockConfigInput = Partial<
  Omit<ImageVariableWidthBlockConfig, keyof ImageVariableWidthBlockRuntimeConfig> &
    ImageVariableWidthBlockRuntimeConfig
>;
export type ImageVariableWidthBlockResolvedConfig = Omit<
  ImageVariableWidthBlockConfig,
  keyof ImageVariableWidthBlockRuntimeConfig
> &
  Partial<ImageVariableWidthBlockRuntimeConfig>;
export interface ImageVariableWidthBlockContract extends ConfigComponentContract<
  ImageVariableWidthBlockConfigInput,
  ImageVariableWidthBlockResolvedConfig
> {}

@Component({
  selector: 'app-image-variable-width-block',
  templateUrl: './image-variable-width-block.component.html',
  standalone: false,
})
export class ImageVariableWidthBlockComponent implements ImageVariableWidthBlockContract {
  readonly config = input<ImageVariableWidthBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ImageVariableWidthBlockConfig,
    ImageVariableWidthBlockRuntimeConfig
  >(imageVariableWidthBlockResolveConfig, () => ({ config: this.config() }));
  get image(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['image'] as unknown as IContentBuilderFieldImage | undefined;
  }
  /** When false, skip container + max-width + padding. Missing key → true (legacy). */
  get useContainer(): boolean {
    return this.resolvedConfig()['use_container'] !== false;
  }
  get property(): string {
    return this.resolvedConfig()['property'] as unknown as string;
  }
  get width(): string {
    return this.resolvedConfig()['width'] as unknown as string;
  }
  get backgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ImageVariableWidthBlockComponent, {
  'keyAliases': {},
});
